import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [], // {id, title, price, quantity}
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
addToCart: (state, action) => {
  const item = state.items.find(i => i.id === action.payload.id);
  if (item) {
    item.quantity += action.payload.quantity ? action.payload.quantity : 1;
    if (item.quantity <= 0) {
      state.items = state.items.filter(i => i.id !== item.id);
    }
  } else {
    state.items.push({ ...action.payload, quantity: 1 });
  }
},

    removeFromCart: (state, action) => {
      state.items = state.items.filter(i => i.id !== action.payload);
    },
    clearCart: (state) => {
      state.items = [];
    }
  }
});

export const { addToCart, removeFromCart, clearCart } = cartSlice.actions;
export default cartSlice.reducer;
